//map script
$("path, circle").hover(function(e) {
    $('#info-box').css('display','block');
    $('#info-box').html($(this).data('info'));
});

$("path, circle").mouseleave(function(e) {
    $('#info-box').css('display','none');
});

$(document).mousemove(function(e) {
    if($('.s-map__map-container').length) {
        $('#info-box').css('top',e.pageY-$('.s-map__map-container').offset().top-$('#info-box').height()-60);
        $('#info-box').css('left',e.pageX-$('.s-map__map-container').offset().left-($('#info-box').width())/2);
    }
}).mouseover();

var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if(ios) {
    $('a').on('click touchend', function() {
        var link = $(this).attr('href');
        window.open(link,'_blank');
        return false;
    });
}
